export { default } from './simple-renderer';
